import { createAction, props } from '@ngrx/store';
import { Event } from '../../models';

export const LoadFeaturedEvents = createAction('[Events] Load Featured Events');
export const LoadFeaturedEventsSuccess = createAction('[Events] Load Featured Events Success', props<{ events: Event[] }>());
export const LoadFeaturedEventsFail = createAction('[Events] Load Featured Events Fail', props<{ error: any }>());
